import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["xlink:href", "height", "width"]
const _hoisted_4 = ["points", "onClick"]
const _hoisted_5 = { class: "body-2 pt-1" }
const _hoisted_6 = { class: "body-2" }
const _hoisted_7 = { class: "text-red" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_AccountableAccountVue = _resolveComponent("AccountableAccountVue")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_accounting_item_edition_embedded = _resolveComponent("accounting-item-edition-embedded")!
  const _component_DocumentAuditActions = _resolveComponent("DocumentAuditActions")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_edit_icon = _resolveComponent("v-btn-edit-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_DocumentAdjustments = _resolveComponent("DocumentAdjustments")!
  const _component_StockOperationDocumentEdition = _resolveComponent("StockOperationDocumentEdition")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_UploadDocument = _resolveComponent("UploadDocument")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "pt-4 pl-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: 12 - _ctx.rightColumnSize,
          class: "pr-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "elevation-0 fill-height rounded-b-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_DocumentMenu, {
                  MenuOptions: _ctx.documentMenuOptions,
                  onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                  onZoomIn: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPDF ? _ctx.zoomInPdf() : _ctx.zoomManager.zoomIn())),
                  onResetZoom: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPDF ? _ctx.resetZoomPdf() : _ctx.zoomManager.resetZoom())),
                  onZoomOut: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isPDF ? _ctx.zoomOutPdf() : _ctx.zoomManager.zoomOut())),
                  onRotateLeft: _cache[4] || (_cache[4] = ($event: any) => (
                        _ctx.documentPdfRotation = _ctx.rotate('left', _ctx.zoomManager, _ctx.documentPdfRotation)
                    )),
                  onRotateRight: _cache[5] || (_cache[5] = ($event: any) => (
                        _ctx.documentPdfRotation = _ctx.rotate('right', _ctx.zoomManager, _ctx.documentPdfRotation)
                    )),
                  onEdit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openAccountingItemEditionDialog())),
                  onDisplayFile: _cache[7] || (_cache[7] = ($event: any) => {
                        _ctx.showAccountingLines = false;
                        _ctx.displayActivity = false;
                    }),
                  onDisplayAccountingLine: _cache[8] || (_cache[8] = ($event: any) => {
                        _ctx.showAccountingLines = true;
                        _ctx.displayActivity = false;
                    }),
                  onDownload: _cache[9] || (_cache[9] = ($event: any) => (_ctx.startDownloadFile())),
                  onUpload: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogUploadDocument = true)),
                  onActivity: _cache[11] || (_cache[11] = ($event: any) => (_ctx.displayActivity = true)),
                  onDelete: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteDocumentDialog = true))
                }, null, 8, ["MenuOptions"]),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    (_ctx.showAccountingLines && !_ctx.displayActivity && _ctx.displayAIStaticFull)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12",
                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                        }, {
                          default: _withCtx(() => [
                            (_ctx.document.id)
                              ? (_openBlock(), _createBlock(_component_accounting_item_static, {
                                  companyId: _ctx.companyId,
                                  documentId: _ctx.document.id,
                                  mode: _ctx.isAccountingItem ? 'AllOption' : 'Embedded',
                                  ref: "accountingItemStatic",
                                  key: _ctx.accountingLinesRefreshKey,
                                  onUpsert: _ctx.onAccountingItemUpdated
                                }, null, 8, ["companyId", "documentId", "mode", "onUpsert"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (_ctx.displayActivity)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12",
                            style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_UsersActivitiesHistory, {
                                documentId: _ctx.document.id
                              }, null, 8, ["documentId"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.isPDF)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "12",
                                  class: "d-flex justify-center",
                                  style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ossPdf, {
                                      ref: "ossPdfRef",
                                      rotation: _ctx.documentPdfRotation,
                                      documentId: _ctx.document.id
                                    }, null, 8, ["rotation", "documentId"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "12",
                                  style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                      (_ctx.document)
                                        ? (_openBlock(), _createElementBlock("svg", {
                                            key: 0,
                                            id: "svg-document-static",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "100%",
                                            viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                            style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                          }, [
                                            _createElementVNode("g", null, [
                                              _createElementVNode("image", {
                                                id: "svg-image-document-static",
                                                "xlink:href": _ctx.document.signedUrl,
                                                x: "0",
                                                y: "0",
                                                height: `${_ctx.imageHeight}px`,
                                                width: `${_ctx.imageWidth}px`
                                              }, null, 8, _hoisted_3),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.svgVariants, (variant, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: `coord-${_ctx.document.id}-${index}`
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.coordinates, (coord, index2) => {
                                                    return (_openBlock(), _createElementBlock("polygon", {
                                                      key: `coord-${_ctx.document.id}-${index}-${index2}`,
                                                      ref_for: true,
                                                      ref: `variants-${index}-${index2}`,
                                                      points: _ctx.getPoints(coord),
                                                      style: _normalizeStyle(
                                                        variant.active
                                                            ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                            : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                    ),
                                                      onClick: _withModifiers(($event: any) => (
                                                        variant.active
                                                            ? ''
                                                            : _ctx.showCorrespondingField({
                                                                  variant,
                                                                  currentIndex: index,
                                                                  copyIndex: index2,
                                                              })
                                                    ), ["stop"]),
                                                      class: _normalizeClass(variant.focus ? 'highlighted' : '')
                                                    }, null, 14, _hoisted_4))
                                                  }), 128))
                                                ], 64))
                                              }), 128))
                                            ])
                                          ], 8, _hoisted_2))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }))
                          ], 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.associatedFields.show)
              ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: `field-${_ctx.document.id}-${key}-${index}`,
                        onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                        class: "oss-list-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, {
                            textContent: _toDisplayString(key)
                          }, null, 8, ["textContent"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: _ctx.rightColumnSize,
          class: "pl-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "rounded-e-0 overflow-y-auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window, {
                  modelValue: _ctx.windowStep,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.windowStep) = $event)),
                  touchless: "",
                  class: "mx-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { step: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          ref: "form",
                          modelValue: _ctx.valid,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.valid) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, {
                                      "single-line": "",
                                      class: "pt-2 pb-0 space-y-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                          ripple: false,
                                          color: "success",
                                          border: "",
                                          rounded: "xl"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "align-center"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "3",
                                                      style: {"border-right":"1px #ededed solid"}
                                                    }, {
                                                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                                                        _createElementVNode("b", null, "Statut", -1)
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "9",
                                                      class: "pl-2 d-flex justify-space-between align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.documentStatus) + " ", 1),
                                                        (
                                                                _ctx.displayAccountingItemEditionEmbedded
                                                            )
                                                          ? (_openBlock(), _createBlock(_component_v_menu, {
                                                              key: 0,
                                                              "offset-y": ""
                                                            }, {
                                                              activator: _withCtx(({ props }) => [
                                                                _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                                                  size: "small",
                                                                  class: "mx-1",
                                                                  color: "secondary"
                                                                }), null, 16)
                                                              ]),
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list, null, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item, {
                                                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (
                                                                        _ctx.accountingItemEditionEmbeddedFullMode =
                                                                            !_ctx.accountingItemEditionEmbeddedFullMode
                                                                    ))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_list_item_title, null, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_icon, { class: "mr-2" }, {
                                                                              default: _withCtx(() => _cache[38] || (_cache[38] = [
                                                                                _createTextVNode("$oss-eye")
                                                                              ])),
                                                                              _: 1
                                                                            }),
                                                                            _createTextVNode(" " + _toDisplayString(_ctx.accountingItemEditionEmbeddedFullMode
                                                                                ? "Cacher les détails de chaque ligne"
                                                                                : "Afficher les détails de chaque ligne"), 1)
                                                                          ]),
                                                                          _: 1
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (
                                                (_ctx.isEditable &&
                                                    _ctx.currentUser.profile.configuration.document
                                                        .write) ||
                                                _ctx.showRestoreDocumentBtn
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              ripple: false,
                                              color: "success",
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid"}
                                                        }, {
                                                          default: _withCtx(() => _cache[39] || (_cache[39] = [
                                                            _createElementVNode("b", null, "Actions", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "d-flex justify-end align-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (
                                                                _ctx.canBeRestoredTooltipMessages?.length
                                                            )
                                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                                  key: 0,
                                                                  class: "pt-4 px-4",
                                                                  location: "bottom"
                                                                }, {
                                                                  activator: _withCtx(({ props }) => [
                                                                    _createElementVNode("div", _mergeProps({ style: {"height":"fit-content"} }, props), [
                                                                      _createVNode(_component_v_btn, {
                                                                        rounded: "",
                                                                        elevation: "0",
                                                                        disabled: "",
                                                                        size: "small"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _cache[41] || (_cache[41] = _createTextVNode(" Restaurer ")),
                                                                          _createVNode(_component_v_icon, {
                                                                            size: "small",
                                                                            location: "end"
                                                                          }, {
                                                                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                                              _createTextVNode(" $oss-edit ")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 1
                                                                      })
                                                                    ], 16)
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canBeRestoredTooltipMessages, (line) => {
                                                                      return (_openBlock(), _createElementBlock("h4", null, _toDisplayString(line), 1))
                                                                    }), 256))
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  (_ctx.showRestoreDocumentBtn)
                                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                        key: 0,
                                                                        rounded: "",
                                                                        elevation: "0",
                                                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.restoreDialog = true)),
                                                                        size: "small"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _cache[43] || (_cache[43] = _createTextVNode(" Restaurer ")),
                                                                          _createVNode(_component_v_icon, {
                                                                            size: "small",
                                                                            location: "end"
                                                                          }, {
                                                                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                                              _createTextVNode(" $oss-edit ")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 1
                                                                      }))
                                                                    : (
                                                                    _ctx.isEditable &&
                                                                    _ctx.currentUser.profile
                                                                        .configuration.document
                                                                        .write
                                                                )
                                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                          key: 1,
                                                                          rounded: "",
                                                                          elevation: "0",
                                                                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.editDialog = true)),
                                                                          "data-cy": "DocumentStatic-edit",
                                                                          size: "small"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _cache[45] || (_cache[45] = _createTextVNode(" Modifier ")),
                                                                            _createVNode(_component_v_icon, {
                                                                              size: "small",
                                                                              location: "end"
                                                                            }, {
                                                                              default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                                                _createTextVNode(" $oss-edit ")
                                                                              ])),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 1
                                                                        }))
                                                                      : _createCommentVNode("", true)
                                                                ], 64))
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (!_ctx.isAccountingItem)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              ripple: false,
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("b", null, _toDisplayString(_ctx.thirdPartyType()), 1)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", null, _toDisplayString(_ctx.document.thirdPartyCompany
                                                                    ? _ctx.document.thirdPartyCompany
                                                                          .name
                                                                    : ""), 1),
                                                            _createElementVNode("div", _hoisted_5, " Siret : " + _toDisplayString(_ctx.document.thirdPartyCompany &&
                                                                _ctx.document.thirdPartyCompany.siret
                                                                    ? _ctx.getSiretValue(
                                                                          _ctx.document.thirdPartyCompany
                                                                              .siret,
                                                                      )
                                                                    : ""), 1),
                                                            _createElementVNode("div", _hoisted_6, " Adresse : " + _toDisplayString(_ctx.fullAddress), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    (
                                            _ctx.activateTagguing &&
                                            _ctx.document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                        )
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 0,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_FreeTag, {
                                                  companyTags: _ctx.allCompanyTags,
                                                  document: _ctx.inDocument,
                                                  splitUserPartitions: true,
                                                  onOnTagsChanged: _ctx.startToBeDoneIfNecessary
                                                }, null, 8, ["companyTags", "document", "onOnTagsChanged"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_divider)
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.displayAccountingItemEditionEmbedded)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12",
                                      class: "mt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          modelValue: _ctx.document.displayName,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.document.displayName) = $event)),
                                          outlined: "",
                                          label: "Nom du document",
                                          "hide-details": "",
                                          density: "compact"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                                        _ctx.isAccountingUser &&
                                        _ctx.currentUser.profile.configuration.accounting.write &&
                                        _ctx.currentUser.profile.configuration.document.write &&
                                        !_ctx.multiAccountableAccount &&
                                        !_ctx.isAccountingItem
                                    )
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.subNetAmounts.length <= 1)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (
                                                !_ctx.document.multiVat &&
                                                _ctx.document.type !== 'BANK_CHARGE' &&
                                                _ctx.document.type !== 'WITHOUT_INVOICE'
                                            )
                                                ? (_openBlock(), _createBlock(_component_v_row, {
                                                    key: 0,
                                                    "no-gutters": "",
                                                    class: "pt-2 flex-grow-1 flex-shrink-0"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_AccountableAccountVue, {
                                                            companyId: _ctx.companyId,
                                                            document: _ctx.document,
                                                            inputStyle: 'padding: 0px; margin: 0px;',
                                                            showSuggestion: false,
                                                            showDescription: true,
                                                            showValidation: false,
                                                            mandatory: false,
                                                            hideDetails: true,
                                                            disabled: _ctx.documentIsInAccountingClosing,
                                                            onClose: _ctx.closeAccountableAccount,
                                                            onSelectAccountableAccount: 
                                                        _ctx.selectAccountableAccount
                                                    
                                                          }, null, 8, ["companyId", "document", "disabled", "onClose", "onSelectAccountableAccount"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : (_openBlock(), _createBlock(_component_v_card, {
                                              key: 1,
                                              class: "mx-auto",
                                              style: {"background":"#fff !important","box-shadow":"none"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_chip_group, null, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subNetAmounts, (item, index) => {
                                                              return (_openBlock(), _createBlock(_component_v_chip, {
                                                                label: "",
                                                                key: index,
                                                                size: "small",
                                                                variant: "outlined"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(item.accountableAccount.name) + " (" + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                item.netAmountSigned,
                                                            )) + ") ", 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            }), 128))
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, {
                                      "single-line": "",
                                      class: "py-0",
                                      density: "compact"
                                    }, {
                                      default: _withCtx(() => [
                                        (!_ctx.displayAccountingItemEditionEmbedded)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              ripple: false,
                                              class: "my-2",
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                            _createElementVNode("b", null, "Type", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.formatCategory(_ctx.document.type)), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                                _ctx.document.invoiceNumber &&
                                                !_ctx.displayAccountingItemEditionEmbedded
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              ripple: false,
                                              class: "my-2",
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("b", null, _toDisplayString(_ctx.invoiceNumberTitle), 1)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.document.invoiceNumber), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                                _ctx.document.date &&
                                                !_ctx.displayAccountingItemEditionEmbedded
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 2,
                                              ripple: false,
                                              class: "my-2",
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                            _createElementVNode("b", null, "Date", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.document.date)), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (
                                                _ctx.dueDateEnable &&
                                                !_ctx.displayAccountingItemEditionEmbedded
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 3,
                                              ripple: false,
                                              class: "my-2",
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "flex-nowrap"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "4",
                                                          class: "flex-grow-0 flex-shrink-1 d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("b", null, _toDisplayString(_ctx.$t("shared.dueDate")), 1)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "8",
                                                          class: "flex-grow-1 flex-shrink-0 pl-1"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_oss_date_picker_filled, {
                                                              "model-value": _ctx.dueDate,
                                                              onChangeDate: _ctx.onDueDateChanged,
                                                              textFieldReadOnly: false,
                                                              hideDetails: true,
                                                              "data-cy": "DocumentStatic-date"
                                                            }, null, 8, ["model-value", "onChangeDate"])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.document.accountingDate)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 4,
                                              ripple: false,
                                              class: "my-2",
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"},
                                                          class: "d-flex align-center"
                                                        }, {
                                                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                            _createElementVNode("b", null, "Date comptable", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.document.accountingDate)), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.document.vatType)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 5,
                                              ripple: false,
                                              class: "my-2",
                                              border: "",
                                              rounded: "xl"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      "no-gutters": "",
                                                      class: "align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "3",
                                                          style: {"border-right":"1px #ededed solid","height":"28px"}
                                                        }, {
                                                          default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                            _createElementVNode("b", null, "Type de TVA", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "9",
                                                          class: "pl-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t(
                                                                `document.vatType.${_ctx.document.vatType}`,
                                                            )), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.displayAccountingItemEditionEmbedded)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 0,
                                  "no-gutters": "",
                                  class: "py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_accounting_item_edition_embedded, {
                                          className: "accounting-item-edition-embedded",
                                          ref: "accountingLinesEditionEmbedded",
                                          companyId: _ctx.companyId,
                                          documentId: _ctx.documentId,
                                          fullMode: _ctx.accountingItemEditionEmbeddedFullMode
                                        }, null, 8, ["companyId", "documentId", "fullMode"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.displayStaticClient)
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 1,
                                    "no-gutters": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex align-center space-x-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[50] || (_cache[50] = _createElementVNode("span", null, "Détails", -1)),
                                          _createVNode(_component_v_divider)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "py-2 mb-2"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_component_accounting_item_static, {
                                            companyId: _ctx.companyId,
                                            documentId: _ctx.inDocument.id,
                                            onUpdate: _ctx.startToBeDoneIfNecessary,
                                            mode: "Payment",
                                            onRefresh: _ctx.onAccountingItemUpdated,
                                            key: _ctx.accountingLinesRefreshKey
                                          }, null, 8, ["companyId", "documentId", "onUpdate", "onRefresh"]))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                            (_ctx.showAudit)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 2,
                                  "no-gutters": "",
                                  class: "py-2 pt-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                                        _createTextVNode(" Révision comptable ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_divider)
                                      ]),
                                      _: 1
                                    }),
                                    (
                                        _ctx.tooltipDocumentAdjustmentBtn ===
                                        'Exercice comptable clôturé'
                                    )
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "auto",
                                          class: "px-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.tooltipDocumentAdjustmentBtn), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.showAudit)
                              ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DocumentAuditActions, {
                                          class: "pa-0 ma-0",
                                          companyId: _ctx.companyId,
                                          document: _ctx.document,
                                          documentId: _ctx.document.id,
                                          documentAccountingPeriod: _ctx.documentAccountingPeriod,
                                          onGoToWindowStep10: _ctx.openWindowStep10,
                                          onGoToWindowStep0: _ctx.setWindowStep
                                        }, null, 8, ["companyId", "document", "documentId", "documentAccountingPeriod", "onGoToWindowStep10", "onGoToWindowStep0"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.enableStock)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 4,
                                  "no-gutters": "",
                                  class: "py-2 pt-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                                        _createTextVNode(" Stocks ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_divider)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.enableStock)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 5,
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "py-1 mb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card, {
                                          class: "default_card_wm mx-auto pt-2",
                                          style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, {
                                              "primary-title": "",
                                              class: "py-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "auto",
                                                      class: "pr-2"
                                                    }, {
                                                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                                                        _createElementVNode("span", null, " Opérations de stock ", -1)
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_col, {
                                                      cols: "auto",
                                                      class: "d-flex justify-end"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                          activator: _withCtx(({ props }) => [
                                                            _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                                              _createVNode(_component_v_btn_edit_icon, {
                                                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.windowStep = 11)),
                                                                size: "x-small",
                                                                variant: "plain"
                                                              })
                                                            ], 16)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 10 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            (_ctx.auditChildren === 'DocumentAdjustments')
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DocumentAdjustments, {
                                      companyId: _ctx.companyId,
                                      thirdPartyCompany: 
                                        _ctx.document.thirdPartyCompany ? _ctx.document.thirdPartyCompany : ''
                                    ,
                                      document: _ctx.document,
                                      documentAcrStatus: _ctx.documentAcrStatus,
                                      documentAccountingPeriod: 
                                        _ctx.documentAccountingPeriod || undefined
                                    ,
                                      acKey: _ctx.adjustmentAcKey,
                                      onBack: _cache[19] || (_cache[19] = ($event: any) => (_ctx.windowStep = 0))
                                    }, null, 8, ["companyId", "thirdPartyCompany", "document", "documentAcrStatus", "documentAccountingPeriod", "acKey"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 11 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            true
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_StockOperationDocumentEdition, {
                                      class: "pa-0 ma-0",
                                      companyId: _ctx.companyId,
                                      documentId: _ctx.documentId,
                                      onBack: _cache[20] || (_cache[20] = ($event: any) => (_ctx.windowStep = 0))
                                    }, null, 8, ["companyId", "documentId"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_card_actions, { class: "d-flex justify-end space-x-1" }, {
                  default: _withCtx(() => [
                    (_ctx.displayAccountingItemEditionEmbedded)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          disabled: _ctx.disabledValidation,
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validAccountingLines())),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[54] || (_cache[54] = [
                            _createTextVNode(" Valider ")
                          ])),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.mode !== 'GeneralLedger')
                      ? (_openBlock(), _createBlock(_component_v_btn_prev, {
                          key: 1,
                          disabled: _ctx.previousDisabled(),
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.previous()))
                        }, null, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.mode !== 'GeneralLedger')
                      ? (_openBlock(), _createBlock(_component_v_btn_next, {
                          key: 2,
                          disabled: _ctx.nextDisabled(),
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.next()))
                        }, null, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogChooseDownload,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
      title: "Télécharger le document",
      width: "800px"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => {
                            _ctx.dialogChooseDownload = false;
                            _ctx.downloadFile(true);
                        }),
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                    _createTextVNode("Original")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => {
                            _ctx.dialogChooseDownload = false;
                            _ctx.downloadFile(false);
                        }),
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[56] || (_cache[56] = [
                    _createTextVNode("Marqué")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[57] || (_cache[57] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté). "))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.orphelinDepreciationAcrId && _ctx.orphelinDepreciationAcrId.length)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.deleteOrphelinDocumentDialog,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.deleteOrphelinDocumentDialog) = $event)),
          title: "Supprimer le contrôle orphelin",
          error: true,
          onValid: _cache[29] || (_cache[29] = ($event: any) => (_ctx.deleteAuditCheckResult(_ctx.orphelinDepreciationAcrId))),
          validTitle: 'Valider la suppression des amortissements automatiques',
          validLoading: _ctx.deleteOrphelinDocumentLoading,
          width: "800px"
        }, {
          default: _withCtx(() => [
            (_ctx.editionMessage && _ctx.editionMessage.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: _ctx.editionMessage
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "validLoading"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => [
        (_ctx.editionMessage && _ctx.editionMessage.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.editionMessage
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true),
        _cache[58] || (_cache[58] = _createElementVNode("h4", { class: "pb-4" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1))
      ]),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editDialog) = $event)),
      title: "Editer le document",
      onValid: _cache[32] || (_cache[32] = ($event: any) => {
            _ctx.editDocument();
            _ctx.editDialog = false;
        }),
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.editLoading,
      prefixDataCy: "DocumentStatic-editer",
      width: "800px"
    }, {
      default: _withCtx(() => _cache[59] || (_cache[59] = [
        _createElementVNode("h4", { class: "text-center" }, " Êtes-vous sûr(e) de vouloir éditer le document ? Si vous validez les lettrages éventuels seront supprimés ", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.restoreDialog,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.restoreDialog) = $event)),
      title: "Restaurer le document",
      onValid: _cache[34] || (_cache[34] = ($event: any) => {
            _ctx.restoreDocument();
            _ctx.restoreDialog = false;
        }),
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.restoreLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[60] || (_cache[60] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir restaurer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "validLoading"]),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 1,
          id: _ctx.document.chat ? _ctx.document.chat.id : '',
          status: 'INFORMATION_REQUEST'
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogUploadDocument,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dialogUploadDocument) = $event)),
      title: "Importer un document pour ce justificatif",
      "max-width": "60vw",
      actions: _ctx.actions
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UploadDocument, {
          showFirstPrevious: false,
          companyId: _ctx.companyId,
          documentId: _ctx.document.id,
          documentType: 'MISCELLANEOUS',
          multiple: false,
          actions: _ctx.actions,
          freeTag: false,
          onFileUploaded: _cache[35] || (_cache[35] = ($event: any) => {
                _ctx.closeUploadDocumentDialog();
                _ctx.startToBeDoneIfNecessary();
            })
        }, null, 8, ["companyId", "documentId", "actions"])
      ]),
      _: 1
    }, 8, ["modelValue", "actions"])
  ], 64))
}